import { LandingPageDestination } from '@dtx-company/inter-app/src/types/flowcode'

/**
 *
 * Updates value for scan destinations that do not construct full URLs.
 *
 */
export function constructScanDestinationLink(value: string, type: LandingPageDestination): string {
  if (type === LandingPageDestination.INSTAGRAM && value?.[0] === '@') {
    return `https://instagram.com/${value.slice(1)}`
  }

  // Youtube URL do include the '@' symbol as part of the username in the URL
  // as oposed to instagram which doesn't
  if (type === LandingPageDestination.YOUTUBE && value?.[0] === '@') {
    return `https://youtube.com/${value}`
  }

  return value
}
